import type { Size } from '../types'

export function ConfluenceIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 20"
      fill="none"
    >
      <g clipPath="url(#clip0_1401_16856)">
        <path
          d="M0.74738 15.268C0.532694 15.6177 0.289545 16.0276 0.0976283 16.352C0.0553416 16.4244 0.0285058 16.5049 0.0163077 16.5879C0.00472867 16.6712 0.0091447 16.7559 0.029319 16.8375C0.0488359 16.9197 0.084617 16.9961 0.133409 17.0644C0.182202 17.1327 0.244005 17.1913 0.314754 17.2368L4.62719 19.8952C4.70119 19.9415 4.78495 19.9724 4.87196 19.9863C4.95816 20.0001 5.04762 19.9968 5.133 19.9757C5.21839 19.9545 5.2989 19.9171 5.36964 19.8651C5.44039 19.813 5.49976 19.7472 5.54448 19.6715C5.71851 19.382 5.93889 19.0072 6.17553 18.6071C7.88489 15.8039 9.61702 16.1471 12.7113 17.6182L16.9887 19.6463C17.0688 19.6848 17.1558 19.7066 17.2445 19.7107C17.3333 19.7147 17.4219 19.7009 17.5051 19.6699C17.5881 19.639 17.6645 19.5919 17.7288 19.5309C17.7938 19.4699 17.845 19.3967 17.8808 19.3154L19.9342 14.6858C19.9691 14.6077 19.9887 14.5239 19.9911 14.4386C19.9943 14.354 19.9805 14.2686 19.9512 14.1889C19.922 14.1092 19.8781 14.0352 19.8211 13.9718C19.7642 13.9084 19.6959 13.8571 19.6186 13.8189C18.7168 13.3944 16.9221 12.5592 15.3135 11.7721C9.46251 8.94942 4.52554 9.13564 0.74738 15.268Z"
          fill="url(#paint0_linear_1401_16856)"
        />
        <path
          d="M20.0829 4.74415C20.3001 4.39447 20.5432 3.98542 20.7327 3.66095C20.7758 3.58695 20.8042 3.50482 20.8164 3.41943C20.8286 3.33486 20.8238 3.24785 20.8026 3.1649C20.781 3.08175 20.7434 3.00359 20.692 2.93476C20.6407 2.86573 20.5763 2.80743 20.5025 2.76317L16.1966 0.104803C16.1218 0.0584499 16.0389 0.027548 15.9518 0.0137235C15.8648 -0.000100978 15.7762 0.00396505 15.6908 0.0242952C15.6054 0.0454386 15.5249 0.0828461 15.4542 0.134891C15.3834 0.186937 15.324 0.252806 15.2785 0.328434C15.1085 0.617936 14.8841 0.992824 14.6475 1.39292C12.9316 4.20906 11.2157 3.86588 8.11823 2.39479L3.84483 0.365842C3.76513 0.327621 3.67893 0.304851 3.59111 0.299972C3.50328 0.29428 3.41464 0.307291 3.33169 0.336566C3.24875 0.365842 3.17231 0.411381 3.10725 0.470746C3.04138 0.53011 2.98933 0.601672 2.95193 0.681366L0.89858 5.32396C0.828011 5.48143 0.821305 5.66014 0.879876 5.82246C0.909152 5.90296 0.953878 5.97697 1.0108 6.0404C1.06773 6.10383 1.13685 6.15587 1.2141 6.19328C2.1192 6.61859 3.91395 7.45294 5.51922 8.24093C11.3548 11.0628 16.3072 10.8773 20.0829 4.74415Z"
          fill="url(#paint1_linear_1401_16856)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1401_16856"
          x1="19.7959"
          y1="21.2718"
          x2="6.76828"
          y2="13.7847"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0052CC" />
          <stop
            offset="0.92"
            stopColor="#2380FB"
          />
          <stop
            offset="1"
            stopColor="#2684FF"
          />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1401_16856"
          x1="1.03382"
          y1="-1.2622"
          x2="14.0646"
          y2="6.22491"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0052CC" />
          <stop
            offset="0.92"
            stopColor="#2380FB"
          />
          <stop
            offset="1"
            stopColor="#2684FF"
          />
        </linearGradient>
        <clipPath id="clip0_1401_16856">
          <rect
            width="20.8333"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
